import FilterNoneOutlinedIcon from '@mui/icons-material/FilterNoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { Box, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import logo_dekalb_svg from '/@/components/new-login/assets/logo_dekalb.svg?url';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { trackEvent } from '/@/store/tracking/actions';
import { formatDate } from '/@/utils';
import useIsMobile from '/@/utils/hooks/is-mobile';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const InfoHeader = ({ field, cropMonitoring }) => {
    useEffect(() => {
        if (cropMonitoring) {
            const date = new Date(cropMonitoring && cropMonitoring.plantingDate);
            setPlantingDate(formatDate(date));
        }
    }, []);

    const dispatch = useDispatch();
    const history = useNavigate();
    const isMobile = useIsMobile();

    const [plantingDate, setPlantingDate] = useState(undefined);
    const handleOnClick = (v) => {
        dispatch(trackEvent({ key: 'cornCropMonitoring.detail.back' }));
        history(reverse('cropMonitoring.CropMonitoring'));
    };

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: cropMonitoring ? 'auto auto auto auto auto auto' : '150px min-content auto',
                gap: '15px',
                alignItems: 'center',
            }}
        >
            <Grid sx={{ mr: 3 }}>
                <Grid container>
                    <img src={logo_dekalb_svg} alt='' style={{ height: '50px' }} />
                </Grid>
            </Grid>

            <Grid>
                <Grid container alignItems='center' wrap='nowrap' spacing={2}>
                    <Grid item>
                        <FilterNoneOutlinedIcon sx={{ color: (t) => t.palette.primary.main, fontSize: 18 }} />
                    </Grid>
                    <Grid item>
                        <Grid container direction='column'>
                            <Grid item>{_('Lote')}</Grid>
                            <Grid item className={`${styles.bold} mp-mask`}>
                                {field && field.name}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid>
                <Grid container alignItems='center' wrap='nowrap' spacing={2}>
                    <Grid item>
                        <LocationOnOutlinedIcon sx={{ color: (t) => t.palette.primary.main, fontSize: 18 }} />
                    </Grid>
                    <Grid item>
                        <Grid container direction='column'>
                            <Grid item>{_('Ubicación')}</Grid>
                            <Grid item className={styles.bold}>
                                {field && field.location}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {Boolean(plantingDate) && (
                <Grid>
                    <Grid container alignItems='center' wrap='nowrap' spacing={2}>
                        <Grid item>
                            <Title theme={settings.app.theme}>
                                <i
                                    className='material-icons'
                                    style={{ fontSize: '14px', display: 'flex', alignItems: 'flex-end' }}
                                >
                                    event
                                </i>
                            </Title>
                        </Grid>
                        <Grid item>
                            <Grid container direction='column'>
                                <Grid item>{_('Fecha de siembra')}</Grid>
                                <Grid item className={styles.bold}>
                                    {plantingDate}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            {cropMonitoring && (
                <Grid>
                    <Grid container alignItems='center' wrap='nowrap' spacing={2}>
                        <Grid item>
                            <Title theme={settings.app.theme}>
                                <i
                                    className='material-icons'
                                    style={{ fontSize: '14px', display: 'flex', alignItems: 'flex-end' }}
                                >
                                    spoke
                                </i>
                            </Title>
                        </Grid>
                        <Grid item>
                            <Grid container direction='column'>
                                <Grid item>{_('Producto')}</Grid>
                                <Grid item className={styles.bold}>
                                    {cropMonitoring.hasGenericProduct
                                        ? _('Híbrido Genérico')
                                        : cropMonitoring.productName}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            {!isMobile && Boolean(cropMonitoring) && (
                <Grid item>
                    <Button onClick={handleOnClick} variant='contained'>
                        {_('Volver al Menú de Seguimientos')}
                    </Button>
                </Grid>
            )}
        </Box>
    );
};

export default InfoHeader;
